import { render, staticRenderFns } from "./CompDBItemList.vue?vue&type=template&id=0e6a3e9a&"
import script from "./CompDBItemList.vue?vue&type=script&lang=js&"
export * from "./CompDBItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports